module.exports = __webpack_public_path__ + "src/assets/bs.404bd625.png";